export default new Proxy({
    routePrefix: '',
    apiUrl: '',
    JWT: '',
    configCatSDKKey: '',
    configure: function (config) {
        Object.assign(this, config);
    },
}, {
    get(target, property) {
        const value = Reflect.get(target, property);
        if (property === 'JWT' && typeof value === 'function') {
            return value();
        }
        return value;
    },
});
